module.exports = __webpack_public_path__ + "bf59c246268443fbcee10b75cae2f6b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/marquise@2x.png
// module id = 307
// module chunks = 0